export default function RadioButtons({
	options,
	value,
	onChange,
	isDisabled = false
}: any) {
	return (
		<div className="radio">
			{options.map((option: any) => {
				let nodash = option.replace(/-/g, " ");
				if (nodash === "onetime") nodash = "one-time";
				const label = nodash.charAt(0).toUpperCase() + nodash.slice(1);
				return (
					<label
						key={option}
						className={`btn btn-secondary ${
							value === option ? "active" : ""
						} ${(isDisabled) ? "disabled" : ""}`}
					>
						<input
							type="radio"
							name="options"
							id={value}
							onChange={() => onChange(option)}
							checked={value === option}
							disabled={isDisabled}
						/>
						{label}
					</label>
				);
			})}
		</div>
	);
}
